import * as z from "zod/v4";

export const licensePlateLabelSize = ["2x1", "4x1"] as const;
export type LicensePlateLabelSize = (typeof licensePlateLabelSize)[number];

export const generateLicensePlate = {
  name: "generateLicensePlate" as const,
  input: z.object({
    returnItemId: z.string().min(1),
    sku: z.string().optional(),
    productTitle: z.string().optional(),
    variantTitle: z.string().optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    labelSize: z.enum(licensePlateLabelSize).optional(),
  }),
  output: z.object({ pdfUrl: z.string(), printed: z.boolean().optional() }),
};
